import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import FeeStructureELe from '../FeeStructure/FeeStructureELe'


function Main() {
    return (
      <>
            <Header/>
            <Breadcrumb title="Home" subtitle="Fee Structure"/>
            <FeeStructureELe />
      </>
    )
  }
  
  export default Main